module.exports = __webpack_public_path__ + "static/img/doorder-logo.fc7c58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/doorder-logo.png
// module id = kr0C
// module chunks = 0